import { render, staticRenderFns } from "./TablesSlot.vue?vue&type=template&id=0db91242&"
import script from "./TablesSlot.vue?vue&type=script&lang=js&"
export * from "./TablesSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports